import JsxHelper from '../Helpers/JsxHelper';
import React from 'react';
import CountryText from '../Elements/CountryText';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import EvaluatorPaymentItem from './EvaluatorPaymentItem';
import LongText from '../Elements/LongText';

export default class EvaluatorPaymentAdminItem extends EvaluatorPaymentItem {
  static nameOfTheItemDetailList() {
    return 'Assignment Payment';
  }

  static clickOnGlobalSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static clickOnSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static selectedStatus() {
    return false;
  }

  static getSelectedCellContent(item) {
    return (
      <input
        type='checkbox'
        checked={item.Selected}
        onChange={(e) => {
          EvaluatorPaymentAdminItem.clickOnSelect(item, e.target.checked);
        }}
      />
    );
  }

  static getSelectedCellHeader(item) {
    return (
      <input
        type='checkbox'
        checked={EvaluatorPaymentAdminItem.selectedStatus()}
        onChange={(e) => {
          EvaluatorPaymentAdminItem.clickOnGlobalSelect(item, e.target.checked);
        }}
      />
    );
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: EvaluatorPaymentAdminItem.getSelectedCellHeader,
        orderById: '',
        data: EvaluatorPaymentAdminItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      {
        label: 'Apollo Job ID',
        orderById: 'AsSassieAsgnId',
        data: 'AsSassieAsgnId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 70,
      },
      { label: 'Evaluator', orderById: 'AsEvname', data: 'AsEvname', minWidth: 100 },
      {
        label: 'Client',
        orderById: 'ClientName',
        data: (item) => (
          <LongText
            text={item.ClientName}
            maxLength={30}
          />
        ),
      },
      {
        label: 'Project',
        orderById: 'ProjectId',
        data: (item) => (
          <LongText
            text={item.ProjectIdAndName}
            maxLength={30}
          />
        ),
        minWidth: 100,
      },
      { label: 'Type', orderById: 'IeType', data: 'IeType', minWidth: 120 },
      { label: 'Status', orderById: 'IeStatus', data: 'IeStatus', minWidth: 50 },
      // CD-5421: sits directly after Status on purpose - it is what explains a Closed payment.
      {
        label: 'Paid Outside of System',
        orderById: 'PaidOutsideOfSystem',
        data: (item) => JsxHelper.YesNo(item.PaidOutsideOfSystem),
        minWidth: 20,
      },
      { label: 'Fee', orderById: 'IeFeeDisplay', data: 'IeFeeDisplay', minWidth: 50 },
      { label: 'Fee Addit.', orderById: 'IeFeeAdjustment', data: 'IeFeeAdjustment', minWidth: 50 },
      { label: 'Expense', orderById: 'IeExpense', data: 'IeExpense', minWidth: 50 },
      { label: 'Tax', orderById: 'IeVat', data: 'IeVat', minWidth: 50 },
      { label: 'Completed On', orderById: 'AsEvaluatorCompletedDate', data: 'AsEvaluatorCompletedDate', minWidth: 50 },
      { label: 'Created On', orderById: 'IeCreatedOn', data: 'IeCreatedOn', minWidth: 50 },
      {
        label: 'Location',
        orderById: 'CuName',
        data: (item) => (
          <LongText
            text={item.CuName == null ? '' : item.CuName}
            maxLength={30}
          />
        ),
        minWidth: 50,
      },
      { label: 'Country', orderById: 'CuCountry', data: (item) => <CountryText Code={item.CuCountry} />, minWidth: 50 },
      {
        label: ' ',
        orderById: '',
        data: EvaluatorPaymentItem.getActionCellContent,
        type: FieldTypesEnum.ActionButton,
        minWidth: 50,
      },
    ];
  }
}
